import { render, staticRenderFns } from "./point-list.vue?vue&type=template&id=389d67f2&scoped=true"
import script from "./point-list.vue?vue&type=script&lang=js"
export * from "./point-list.vue?vue&type=script&lang=js"
import style0 from "./point-list.vue?vue&type=style&index=0&id=389d67f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d67f2",
  null
  
)

export default component.exports